// extracted by mini-css-extract-plugin
module.exports = {"list__wrapper":"index_list__wrapper__H8Bsk","filter__wrapper":"index_filter__wrapper__3DomZ"};